import { gql } from '@apollo/client';
import { UserData } from './account-data';

export const GET_ACCOUNT_ITEMS = gql`
  query User_getList($query: QueryUserInput) {
    User_getList(query: $query) {
      data {
        ${UserData}
      }
      count
      page
      pages
      limit
    }
  }
`;

export const UPDATE_ACCOUNT = gql`
mutation User_update($payload: UpdateUserInput!) {
  User_update(updateUserInput: $payload) {
    ${UserData}
  }
}
`;

export const FIND_ACCOUNT = gql`
query User_getById($id: String!) {
  User_getById(id: $id) {
    ${UserData}
  }
}
`;

export const FIND_PERMISSION = gql`
  query User_getPermission {
    User_getPermission
  }
`;

export const CREATE_ACCOUNT = gql`
mutation User_create($payload: CreateUserInput!) {
  User_create(createUserInput: $payload) {
    ${UserData}
  }
}
`;

export const RESET_MFA = gql`
mutation User_resetMfa($id: String!) {
  User_resetMfa(id: $id) {
    ${UserData}
  }
}
`;

export const UPDATE_REQUIRED_MFA = gql`
mutation User_updateRequiredMfa($payload: UpdateRequiredMfaInput!) {
  User_updateRequiredMfa(updateRequiredMfaInput: $payload) {
    ${UserData}
  }
}
`;

export const CHANGE_PASSWORD = gql`
mutation User_changePassword($payload: ChangePasswordInput!) {
  User_changePassword(changePasswordInput: $payload) {
    ${UserData}
  }
}
`;

export const CHANGE_EMAIL = gql`
mutation User_changeEmail($payload: ChangeEmailInput!) {
  User_changeEmail(changeEmailInput: $payload) {
    ${UserData}
  }
}
`;
